
@mixin transition {
  transition: all 0.125s ease 0s!important;
}

@mixin hover {
  &:hover {
    transform: scale(1.05)!important;
  }
}

@mixin active {
  &:active {
    transform: scale(0.925)!important;
  }
}

.hover {
  @include transition;
  @include hover;
}

.active {
  @include transition;
  @include active;
}

.hoverActive {
  @include transition;
  @include hover;
  @include active;
}
